import React, { useContext, useEffect, useState } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Bottombar from '../Bottombar'
import Navbar from '../Navbar'
import Settings from '../Settings'
import Notification from '../Notification'
import { ApiContext } from '../../context/ApiContext'
import { NavbarContext } from '../../context/NavbarContext'
import Sliderss from '../Sliderss'
// import { Sidebar } from 'lucide-react'
import appIcon from '../../assets/favicon.png'
import Sidebar from '../Sidebar'
import { SideberContext } from '../../context/SidebarContext'


function AllPagiesLayout() {
  const { setRss, setCategories3_id, data, audioRef, audiosRef, audioUrl, handleTimeUpdate, isPlayings, setIsPlayings, audioSrc, innerAudioRef, handleLoadedMetadata, interviewsaudioRef, interviewshandleTimeUpdate, audioSrc555, isApple, setIsApple,deferredPrompt, setDeferredPrompt } = useContext(ApiContext);
  const { setNavHeading } = useContext(NavbarContext)
  const { mySidebar, setMySidebar } = useContext(SideberContext)
  const location = useLocation();
  const [isVisible, setIsVisible] = useState(false);
 
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    const handleBeforeInstallPrompt = (e) => {
      e.preventDefault();
      if (!isDismissed) {
        // Only save the prompt if the user has not dismissed it
        setDeferredPrompt(e);
      }
    };

    window.addEventListener("beforeinstallprompt", handleBeforeInstallPrompt);

    return () => {
      window.removeEventListener("beforeinstallprompt", handleBeforeInstallPrompt);
    };
  }, [isDismissed]);


  const closePopup = () => {
    setIsVisible(false);
  };
  const handleInstallClick = () => {
    if (isApple) {
      if (navigator.standalone) {
        setIsVisible(false)
      } else {
        setIsVisible(true)
        setIsApple(false)
        setDeferredPrompt(null);
      }

    } else if (deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then((choiceResult) => {
        if (choiceResult.outcome === "accepted") {
          // console.log("User accepted the install prompt");
          setDeferredPrompt(null);
        } else {
          // console.log("User dismissed the install prompt");
          setDeferredPrompt(null); // Reset the prompt after dismissal
          setIsDismissed(true);
        }
        setDeferredPrompt(null);
      });
    }
  };

  useEffect(() => {
    if (location.pathname === "/podcast") {
      setNavHeading("Podcast");
    } else if (location.pathname === "/schedule") {
      setNavHeading("Schedule");
    } else if (location.pathname === "/news") {
      setNavHeading("News");
    } else if (location.pathname === "/events") {
      setNavHeading("Events");
    } else if (location.pathname === "/myevents") {
      setNavHeading("Events");
    } else if (location.pathname === "/albums") {
      setNavHeading("Albums");
    }else if (location.pathname === "/interviews") {
      setNavHeading("Interviews");
    }
  }, [location.pathname, data])

  useEffect(() => {
    if (location.pathname === "/") {
      if (data) {
        setNavHeading(data.app_name)

      }
    }
    if (location.pathname !== "/player") {
      setRss(null);
      setCategories3_id(null);
    }
    if (location.pathname !== "/videoplayer") {
      setMySidebar(false)
    }

  }, [location.pathname, data]);


  return (
    <>
      <div style={{margin:"0px",padding:"0px"}} onClick={handleInstallClick}>
        {/* {audioSrc &&( */}
        <>
          <audio
            ref={interviewsaudioRef}
            src={audioSrc555}
            onTimeUpdate={interviewshandleTimeUpdate}
            onLoadedMetadata={interviewshandleTimeUpdate}
          />
        </>
        <>
          <audio
            ref={innerAudioRef}
            src={audioSrc}
            onTimeUpdate={handleTimeUpdate}
            onLoadedMetadata={handleLoadedMetadata}
          />
          {/* {audioSrc?handleLoadedMetadata():""} */}
        </>
        {/* )} */}
        {data && data.radio_stream && (
          <>
          
          {/* {console.log(data.radio_stream,"rgio")} */}
          <audio
            src={data.radio_stream}            
            ref={audioRef}
            crossOrigin="anonymous"
          // autoPlay 
          // controls
          />
          </>
        )}
        <Navbar />
       {data&&<>
        <Sidebar />
        <Settings />
        <Notification />
        {isVisible && (<>
          <div className="install-popup" onClick={closePopup}>
            {/* {console.log(isVisible, "is visible")} */}
            <div className="popup-content" onClick={(e) => e.stopPropagation()}>
              <div className="popup-header">
                <button className="close-button" onClick={closePopup}>×</button>
              </div>
              <div className="popup-body">
                <img src={appIcon} alt="App Icon" className="app-icon" />
                <p>
                  To install this app, please open Safari and click the "Share" button,
                  then select "Add to Home Screen".
                </p>
              </div>
            </div>
          </div>
        </>)}
        <Sliderss />
       </>}
        <Outlet />

        <Bottombar />
      </div>
    </>
  )
}

export default AllPagiesLayout;
